import "../styles/main.scss";
import "bootstrap";
import $ from "jquery";
import {Prop65Modal} from "../components/prop65Modal.js";

$(function () {
    Prop65Modal();
});
